// client/src/App.jsx - Composant racine
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import MealPlanPage from './pages/MealPlanPage';
import ShoppingListPage from './pages/ShoppingListPage';
import ProfilePage from './pages/ProfilePage';
import SubscriptionPage from './pages/SubscriptionPage';
import InspirationsRepasPage from './pages/InspirationsRepasPage';
import MenuSemainePage from './pages/MenuSemainePage';
import CuisinerSansGaspillerPage from './pages/CuisinerSansGaspillerPage';
import UserRecipesPage from './pages/UserRecipesPage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import NoterRecettesPage from './pages/NoterRecettesPage';
import FAQPage from './pages/FAQPage';
import CGVPage from './pages/CGVPage';
import CGUPage from './pages/CGUPage';
import ConfidentialitePage from './pages/ConfidentialitePage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import CookingAssistantPage from './pages/CookingAssistantPage';
import PricingPage from './pages/PricingPage';
import SuspendedPage from './pages/SuspendedPage';
import PublicRecipePage from './pages/PublicRecipePage';
import ComboDetailPage from './pages/ComboDetailPage';
import BlogPage from './pages/BlogPage';
import PublicRecipesListPage from './pages/PublicRecipesListPage';

import IngredientBenefitDetailPage from './pages/IngredientBenefitDetailPage';
import ContactPage from './pages/ContactPage';

// Composants
import Header from './components/Header';
import Footer from './components/Footer';
import QuotaModal from './components/QuotaModal';
import { trackPageview } from './utils/analytics';

const RouteChangeTracker = () => {
  const location = useLocation();
  React.useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);
  return null;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <RouteChangeTracker />
          <Header />
          <QuotaModal />
          <main className="flex-grow w-full max-w-full sm:container mx-auto py-4 sm:px-4 sm:py-8 flex flex-col justify-center">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/test" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/idees-de-repas" element={<PublicRecipesListPage />} />
              <Route path="/idees-de-repas/idees-recette/:Recipe__url/:Recipe___id" element={<PublicRecipePage />} />
              <Route path="/idees-de-repas/idees-recettes/:Ingredient__slug/:Ingredient___id" element={<IngredientBenefitDetailPage />} />
              <Route path="/idees-recettes/combinaison-avec/:Combo__slug/:Combo___id" element={<ComboDetailPage />} />
              {/* PRIVATES ROUTES */}
              <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
              <Route path="/inspirations-repas" element={<PrivateRoute><InspirationsRepasPage/></PrivateRoute>} />
              <Route path="/menu-semaine" element={<PrivateRoute><MenuSemainePage/></PrivateRoute>} />
              <Route path="/cuisiner-sans-gaspiller" element={<PrivateRoute><CuisinerSansGaspillerPage/></PrivateRoute>} />
              <Route path="/noter-recettes" element={<PrivateRoute><NoterRecettesPage/></PrivateRoute>} />
              <Route path="/meal-plans/:id" element={<PrivateRoute><MealPlanPage /></PrivateRoute>} />
              <Route path="/mes-recettes" element={<PrivateRoute><UserRecipesPage /></PrivateRoute>} />
              <Route path="/recette/:recipeId" element={<PrivateRoute><RecipeDetailPage /></PrivateRoute>} />
              <Route path="/shopping-lists/:id" element={<PrivateRoute><ShoppingListPage /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
              <Route path="/subscription" element={<PrivateRoute><SubscriptionPage /></PrivateRoute>} />
              <Route path="/cooking-assistant" element={<PrivateRoute><CookingAssistantPage /></PrivateRoute>} />
              {/* STATIQUES LEGALES ROUTES */}
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/suspended" element={<SuspendedPage />} />
              <Route path="/cgv" element={<CGVPage />} />
              <Route path="/cgu" element={<CGUPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/confidentialite" element={<ConfidentialitePage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
